import { getActivityLog } from "api/api";

export const FETCH_ACTIVITY_LOG_FULFILLED = "FETCH_ACTIVITY_LOG_FULFILLED";
export const FETCH_ACTIVITY_LOG_PENDING = "FETCH_ACTIVITY_LOG_PENDING";
export const FETCH_ACTIVITY_LOG_REJECTED = "FETCH_ACTIVITY_LOG_REJECTED";
export const CLEAR_ACTIVITY_LOG = "CLEAR_ACTIVITY_LOG";

export const fetchActivityLogStart = () => {
  return {
    type: FETCH_ACTIVITY_LOG_PENDING,
  };
};

export const fetchActivityLogSuccess = (response) => {
  return {
    type: FETCH_ACTIVITY_LOG_FULFILLED,
    data: response,
  };
};

export const fetchActivityLogFail = (error) => {
  return {
    type: FETCH_ACTIVITY_LOG_REJECTED,
    error: error,
  };
};

export const fetchActivityLog = () => {
  return async (dispatch) => {
    dispatch(fetchActivityLogStart());
    getActivityLog()
      .then((response) => {
        dispatch(fetchActivityLogSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchActivityLogFail(error));
      });
  };
};
export const clearActivityLog = () => {
  return {
    type: CLEAR_ACTIVITY_LOG,
  };
};
export const clearActivity = () => {
  return async (dispatch) => {
    dispatch(clearActivityLog());
  };
};
